import React from "react";
import axios from "axios";

export const allApplicationsApi = async (token) => {
  try {
    let url = `https://visapro-api.tcore.online/api/v1/applications`;

    const response = await axios.get(url,{
        headers: {
            'Authorization': `Bearer ${token}` 
          },
    });
    const applications = {
      data: response.data,
    };
    return applications;
  } catch (error) {
    const applications = {
      error: error,
    };
    return applications;
  }
};
